import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://kazhavda.mk";
const OG_IMAGE =
  "https://kazhavda-public.s3.eu-central-1.amazonaws.com/og_image_kazhavda.png";

const ROUTE_META = {
  "/": {
    title: "Планирање Свадба | Kazhavda Wedding Planner",
    description:
      "Испланирајте свадба на едно место со kazhavDa: гости, маси, задачи, покани и свадбени идеи. Wedding planning tools за вашиот голем ден.",
    keywords:
      "планирање свадба, организатор за свадба, wedding planner, свадбени идеи, свадбени покани, листа на гости",
  },
  "/venues": {
    title: "Продавници за Свадба | Локации, Бендови и Услуги",
    description:
      "Пронајдете свадбени продавници: локации, кетеринг, бендови и услуги за свадба во Македонија. Venues and vendors за секој стил и буџет.",
    keywords:
      "свадбени локации, продавници за свадба, бенд за свадба, wedding venues, wedding vendors, свадба Македонија",
  },
  "/all-products": {
    title: "Свадбени Продукти | Идеи и Понуди за Свадба",
    description:
      "Разгледајте свадбени продукти и понуди за организација на свадба. Wedding products и инспирација за декорации, детали и подготовка.",
    keywords:
      "свадбени продукти, производи за свадба, wedding products, декорации за свадба, wedding ideas",
  },
  "/contact": {
    title: "Контакт | Kazhavda",
    description:
      "Контактирајте го тимот на kazhavDa за помош околу алатките за планирање свадба.",
    keywords: "контакт, kazhavda, wedding planner support",
  },
  "/login": {
    title: "Најава | Kazhavda",
    description:
      "Најавете се на kazhavDa и продолжете со планирање на свадба: гости, маси, задачи и покани.",
    keywords: "најава, sign in, login, wedding planner account",
  },
  "/sign-up": {
    title: "Креирај Сметка | Kazhavda",
    description:
      "Регистрирајте се на kazhavDa и организирајте ја свадбата со практични wedding planning алатки.",
    keywords: "регистрација, sign up, wedding planner, креирај сметка",
  },
};

function setMetaByName(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setMetaByProperty(property, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setCanonical(url) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

function resolveMeta(pathname) {
  if (ROUTE_META[pathname]) return ROUTE_META[pathname];
  if (pathname.startsWith("/venue/")) {
    return {
      title: "Детали за Локација | Kazhavda",
      description:
        "Погледнете детали за свадбена локација и достапни продукти за организација на свадба.",
      keywords: "свадбена локација, venue details, wedding venue",
    };
  }
  if (pathname.startsWith("/product/")) {
    return {
      title: "Детали за Продукт | Kazhavda",
      description:
        "Погледнете детали за свадбен продукт и слични предлози за вашиот свадбен ден.",
      keywords: "свадбен продукт, product details, wedding product",
    };
  }
  return {
    title: "Kazhavda | Wedding Planner",
    description:
      "kazhavDa е платформа за организирање свадба со алатки за гости, задачи, маси и инспирација.",
    keywords:
      "свадба, планирање свадба, wedding planner, wedding tools, kazhavda",
  };
}

function SeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = resolveMeta(pathname);
    const canonicalUrl = `${SITE_URL}${pathname}`;

    document.title = meta.title;
    setCanonical(canonicalUrl);
    setMetaByName("description", meta.description);
    setMetaByName("keywords", meta.keywords);
    setMetaByName("robots", "index,follow");

    setMetaByProperty("og:title", meta.title);
    setMetaByProperty("og:description", meta.description);
    setMetaByProperty("og:type", "website");
    setMetaByProperty("og:url", canonicalUrl);
    setMetaByProperty("og:image", OG_IMAGE);

    setMetaByName("twitter:card", "summary_large_image");
    setMetaByName("twitter:title", meta.title);
    setMetaByName("twitter:description", meta.description);
    setMetaByName("twitter:image", OG_IMAGE);
  }, [pathname]);

  return null;
}

export default SeoManager;
